import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";

const NAV = [
  { label: "Services", to: "/services" },
  { label: "Case Studies", to: "/case-studies" },
  { label: "Process", to: "/how-we-work" },
  { label: "Contact", to: "/contact" },
];

const SOCIALS = [
  { icon: Linkedin, href: "https://www.linkedin.com/company/upword-media/", label: "LinkedIn" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#111111] text-white">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="bg-white inline-block px-4 pt-3 pb-1 overflow-hidden">
            <img
              src="/upword-logo.png"
              alt="Upword Media"
              className="h-16 w-auto object-contain"
              style={{ clipPath: "inset(0 0 12% 0)" }}
            />
          </div>
          <p className="mt-6 text-[#999999] max-w-sm leading-relaxed">
            The organic growth partner for leading B2B SaaS &amp; tech brands. Bengaluru, India.
          </p>
          <a
            href="mailto:info@getupword.com"
            data-testid="footer-email"
            className="inline-flex items-center gap-2 mt-6 font-serif text-2xl md:text-3xl text-white hover:text-[#E0E0E0] transition-colors group"
          >
            info@getupword.com
            <ArrowUpRight size={22} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>

        <div className="md:col-span-4 md:col-start-8">
          <p className="text-xs uppercase tracking-[0.2em] text-[#666666] mb-6">Navigate</p>
          <ul className="grid grid-cols-2 gap-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-[#E0E0E0] hover:text-white transition-colors link-underline"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>

          <p className="text-xs uppercase tracking-[0.2em] text-[#666666] mt-10 mb-4">Follow</p>
          <div className="flex items-center gap-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="w-11 h-11 border border-[#333333] flex items-center justify-center text-[#E0E0E0] hover:bg-white hover:text-[#111111] transition-colors"
              >
                <s.icon size={18} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#333333] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-sm text-[#666666]">© 2026 Upword Media.</p>
        <p className="text-xs uppercase tracking-[0.2em] text-[#666666]">SEO · AEO · GEO</p>
      </div>
    </div>
  </footer>
);
